<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Area/POA/components/Calendar/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>